export default __webpack_public_path__ + "static/media/gallery-wps-2.e0bae0b0.jpg";